import React from "react";
import {Container, Grid, makeStyles, TextField, WithStyles, withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {isEmail, isBlank, emailToBase64} from "../../utils";
import {Alert} from "@material-ui/lab";
import Card from "@material-ui/core/Card";
import {RouteComponentProps, useParams, withRouter} from "react-router";
import styles from "../health_safety/IncidentSignStyles";
import {IOneplaceLibraryContextProp, withOneplaceLibraryContext} from "oneplace-components";
import {Api} from "../../data_sources/api";
import {createStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

interface AlertProps {
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';

    onClose: () => void;
}

interface EmailAttachmentProps extends
    RouteComponentProps<any>,
    WithStyles<typeof styles>,
    IOneplaceLibraryContextProp{
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            marginTop: '20px'
        },
        rootGrid: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        card: {
            maxWidth: '450px',
            minWidth:'350px',
            padding: '20px'
        },
        alignCenter: {
            textAlign: 'center'
        },
        buttonWrapper: {
            paddingTop: 0,
            position: 'relative',
        },
        buttonProgress: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginLeft: -15,
            marginTop: -2,
        },
    }),
);

export default withStyles(styles)(
    withRouter(
        withOneplaceLibraryContext(
            (props: EmailAttachmentProps) => {

    const [email, setEmail] = React.useState('');
    const [alert, setAlert] = React.useState<AlertProps | null>(null);
    const [loading, setLoading] = React.useState<boolean>(false);
    const params = useParams<{ token: string }>();
    const classes = useStyles();


    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if(isBlank(email) || !isEmail(email)){
            setAlert({
                message: 'Please enter a valid email address',
                severity: 'error',
                onClose: () => setAlert(null)
            })
            return
        }
        try {
            setLoading(true);

            const region = props.match.params.region
            const path = props.match.params.path
            const api = new Api(region, path)
            const successMessage = await api.getMagicDownloadLink(params.token, emailToBase64(email)!)

            setLoading(false);

            setAlert({
                message: successMessage,
                severity: 'success',
                onClose: () => setAlert(null)
            })
        } catch (e: Error | any){
            setAlert({
                message: e.message,
                severity: 'error',
                onClose: () => setAlert(null)
            })

            setLoading(false);
        }
    }

    return (
        <Container maxWidth="sm" className={classes.root}>
            <Grid container spacing={2} className={classes.rootGrid}>
                <Card className={classes.card}>
                    {alert && <Alert {...alert}> { alert.message } </Alert>}
                    <form onSubmit={handleSubmit} method='POST'>
                    <Grid item xs={12} className={classes.alignCenter}>
                        <h3>Get Your Download Link</h3>
                        <Alert severity='info' icon={false}>Enter your email address and we'll send you a secure link to download the attachment</Alert>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label="Email" variant="outlined" fullWidth value={email}
                                   color='primary' name='email' id='email'
                                   autoFocus
                                   data-testid='download-attachment-email-input'
                                   onChange={(e) => setEmail(e.target.value)}
                                   style={{marginBottom: '20px'}} placeholder="Enter your email"/>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.buttonWrapper}>
                            <Button variant="contained" color="primary"
                                    type='submit' id='submit' name='submit'
                                    data-testid='download-attachment-button'
                                    fullWidth size='large'
                                    disabled={loading}
                                    className={classes.root}>
                                Send Download Link
                            </Button>

                            {loading && <CircularProgress size={25} color='primary'
                                                          thickness={6.0} className={classes.buttonProgress} />}
                        </div>
                    </Grid>
                    </form>
                </Card>
            </Grid>

        </Container>
    )
})));